export default "__VITE_ASSET__OoobOQCD__"